/*
     Title: Zone API
     Description: Zone API
     Author: Iqbal Hossain
     Date: 09-January-2022
     Modified: 09-January-2022
*/

export const ZONE_API = {
  root: '/api/zone',
  fetch_all: 'api/zone/fetch-all',
  fetch_by_query: `/api/zone/fetch-by-query`,
  fetch_by_id: `/api/zone/fetch-by-id`,
  add: `/api/zone/add`,
  update: `/api/zone/update`,
  delete: `/api/zone/delete`,
  delete_by_range: `/api/zone/delete-range`
};
